import { render, staticRenderFns } from "./LoadingDialog.vue?vue&type=template&id=bd0963f8&scoped=true&"
import script from "./LoadingDialog.vue?vue&type=script&lang=ts&"
export * from "./LoadingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingDialog.vue?vue&type=style&index=0&id=bd0963f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0963f8",
  null
  
)

export default component.exports